export default "__VITE_ASSET__D$nyzl2P__"